module.exports = __webpack_public_path__ + "static/media/social-yahoo.d82bf83f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/auth/social-yahoo.svg
// module id = 118
// module chunks = 0